import React, { useState, useEffect } from "react";

import UserService from "../../../services/UserService";
import Panel from "../../../components/Panel";
import ManualTerminal from "../../../components/Manual/ManualTerminal";
import ActionListItem from "../ActionListItem";
import {
  useActionDone,
  useActionGroups,
  useDevice,
} from "../../../Api/newSockets.api";
import Joystick from "../../../components/Manual/Joystick";
import Accordion from "../../../components/Accordion/Accordion";
import ActionButton from "../../../components/Buttons/ActionButton";
import DeviceMenu from "./DeviceMenu";
import { NavLink, useLocation } from "react-router-dom";
import DevicesHeader from "../../../components/Header/DevicesHeader";
import { savePathToLocalStorage } from "../../../utils/helpers";

type Props = {
  device: any;
  label: string;
  icon: any;
  match: any;
};

const Actions = (props: Props) => {
  savePathToLocalStorage();

  const deviceId = props.match.params.deviceId;
  const { getDevice } = useDevice();
  // Get Basic info for the device through device ID
  const { device } = getDevice(parseInt(deviceId));
  console.log(device);

  // Get Actions for a specific device with device ID
  const { getActionGroupsByDeviceType } = useActionGroups();
  const { actionGroups } = 
  getActionGroupsByDeviceType(
    parseInt(device?.deviceType)
  );

  return (
    <div className="device-main main-content">
      <DevicesHeader device={device} />
      <div className="manual-body-content">
        {device && (
          <div>
            <DeviceMenu typeId={device.deviceTypes.id} />
          </div>
        )}
        <div className="manual">
          <div className="manual-actions">
            {actionGroups?.map((type: any, i: any) =>
              type?.actions?.length > 0 ? (
                <div key={i}>
                  <h4>{type.name}</h4>
                  {type?.actions?.map((action: any, i: any) => {
                    return (
                      <ActionListItem
                        action={action}
                        deviceId={device.id}
                        key={i}
                      />
                    );
                  })}
                </div>
              ) : (
                ""
              )
            )}
          </div>
          <div className="manual-terminal">
            <ManualTerminal deviceId={deviceId} />
          </div>
        </div>
      </div>
    </div>
  );
};

export default Actions;
